import CryptoJS from "crypto-js"
import  {AES, lib, enc} from "crypto-js"

const key=enc.Utf8.parse(process.env.REACT_APP_ENCRYPTION_KEY || "")
const iv=enc.Utf8.parse(process.env.REACT_APP_ENCRYPTION_IV || "")

export function encrypter(value:string|number){ 
    const hash = AES.encrypt(value.toLocaleString(), key, {
        iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
    })
  
    return hash.toString()
}


export function decrypter(value:string|number){ 

    try{

        const hash = AES.decrypt(value.toString(), key, {
            iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        })
      const response=hash.toString(CryptoJS.enc.Utf8)
        return !!response?response:value.toString()
    }
    catch(ex){
        return value.toString( )
    }
}
